import React from 'react';
import { PlusCircle, Search, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const SalleHeader = ({ 
  searchTerm, 
  setSearchTerm, 
  onAddClick 
}) => {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-r from-[#202654] to-[#3a4999] rounded-xl p-6 mb-8 shadow-lg">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div className="flex items-center text-white">
          <button
            onClick={() => navigate(-1)}
            className="mr-4 p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-all duration-200 backdrop-blur-sm"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
          <div>
            <h1 className="text-2xl font-bold">Gestion des Salles</h1>
            <p className="text-white opacity-80 mt-1">
              Gérez les salles de classe de votre établissement
            </p>
          </div>
        </div>
        <div className="flex gap-4 w-full md:w-auto">
          <div className="relative flex-grow md:flex-grow-0">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <Search className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Rechercher une salle..."
              className="pl-10 pr-4 py-2 w-full md:w-64 bg-white/90 backdrop-blur-sm text-gray-900 rounded-lg"
            />
            {searchTerm && (
              <button
                onClick={() => setSearchTerm('')}
                className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
              >
                <X className="h-4 w-4" />
              </button>
            )}
          </div>
          <button
            onClick={onAddClick}
            className="inline-flex items-center bg-white text-[#202654] px-4 py-2 rounded-lg shadow-md hover:bg-gray-100 transition-all duration-200 whitespace-nowrap"
          >
            <PlusCircle className="h-5 w-5 mr-2" />
            Nouvelle salle
          </button>
        </div>
      </div>
    </div>
  );
};

export default SalleHeader; 